import {each, mapValues} from "lodash"
import {Tenant} from "@irati/types"
import FeatureFlagValues from "../enums/featureFlags"
import FeatureFlags from "../types/ReduxAuth/FeatureFlags"

export function defaultFlags(): FeatureFlags {
  const flags: FeatureFlags = mapValues(FeatureFlagValues, () => {
    /**
     * @desc: Loop through all FeatureFlagValues enum and set a value
     * @example: To set one key to true:
     *  | const flags: FeatureFlags = mapValues(FeatureFlagValues, (key) => {
     *  |   if (key === FeatureFlagValues.isCoolThing) { // should default to true
     *  |     return true
     *  |   }
     *  |   return false
     *  | })
     */
    return false
  })

  return flags
}

export function getFeatureFlag(userTenant: Tenant, flag: FeatureFlagValues) {
  const obj = stringToObject(userTenant)

  return obj[flag]
}

export function setFeatureFlag(userTenant: Tenant, flag: FeatureFlagValues, value: boolean) {
  const obj = stringToObject(userTenant)
  obj[flag] = value
  userTenant.settings.featureFlags = objectToString(obj)
}

/** @description: Helper functions to turn feature flags string into object
 *  @todo: Will change when we create a proper featureFlag service
 */

export function stringToObject(userTenant: Tenant): FeatureFlags {
  try {
    const raw: FeatureFlags = {...defaultFlags(), ...JSON.parse(userTenant.settings.featureFlags)}
    // removing old feature flags not in the typing
    const picked: FeatureFlags = {}
    each(FeatureFlagValues, (_value, key: string) => {
      picked[key] = raw[key]
    })
    return picked
  } catch (e) {
    return defaultFlags()
  }
}

function objectToString(featureFlags: FeatureFlags): string {
  try {
    return JSON.stringify(featureFlags) || ""
  } catch (e) {
    return JSON.stringify(defaultFlags())
  }
}
